import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IItemDetailList, IMaterialDetailList, IAppointmentList,Ids, ItemDetailed, MaterialDetailed, IAppointmentField, IAppointmentSearch, IAppointmentDetail, IAppointmentRoSettleAndWhConfirm } from "./appointmentTypes"

class AppointmentService {
    async page(searchVo: IAppointmentSearch) {
        const apiUrl = "/vrm-sa/appointment/findPage";
        return await httpRequest.post<IAppointmentList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/appointment/findById/${id}`;
        return await httpRequest.get<IAppointmentDetail>(apiUrl);
    }

    async insert(insertVo: IAppointmentField) {
        const apiUrl = "/vrm-sa/appointment/insert";
        return await httpRequest.post<IAppointmentDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IAppointmentField) {
        const apiUrl = "/vrm-sa/appointment/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // 库房确认
    async warehousing(params: IAppointmentRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/appointment/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修用料明细删除
    async materialDelete(params: MaterialDetailed) {
        const apiUrl = "/vrm-sa/appointment/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修项目明细删除
    async itemDelete(params: ItemDetailed) {
        const apiUrl = "/vrm-sa/appointment/itemDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IAppointmentRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/appointment/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/appointment/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/vrm-sa/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/vrm-sa/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //预约转维修
    async transfer(params: object) {
        const apiUrl = "/vrm-sa/appointment/transfer";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //预约批量导出
    async export(params: IAppointmentSearch) {
        const apiUrl = "/vrm-sa/appointment/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    //预约详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/appointment/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
}
export const appointmentService = new AppointmentService();
